import { Navigate, Route, Routes } from "react-router-dom";
import Chrome from "@/components/layout/chrome";

import HomePage from "@/src/pages/home";
import AboutPage from "@/src/pages/about";
import ContactPage from "@/src/pages/contact";

import CourseDetailPage from "@/src/pages/course-detail";
import ArticlesPage from "@/src/pages/articles";
import PyqsPage from "@/src/pages/pyqs";
import CurrentAffairsPage from "@/src/pages/current-affairs";
import CurrentAffairsDetailPage from "@/src/pages/current-affairs-detail";
import MaterialsPage from "@/src/pages/materials";
import MaterialsDetailPage from "@/src/pages/materials-detail";
import BlogPage from "@/src/pages/blog";
import BlogDetailPage from "@/src/pages/blog-detail";
import CareersPage from "@/src/pages/careers";
import PrivacyPage from "@/src/pages/privacy";
import TermsPage from "@/src/pages/terms";
import RefundPolicyPage from "@/src/pages/refund-policy";
import LoginPage from "@/src/pages/login";
import SignupPage from "@/src/pages/signup";
import QuizPage from "@/src/pages/quiz";
import ArticlePage from "@/src/pages/article";
import AdminPage from "@/src/pages/admin";
import AdminResourcesPage from "@/src/pages/admin/resources";
import DashboardPage from "@/src/pages/dashboard";
import ProfilePage from "@/src/pages/profile";
import PyqDetailPage from "@/src/pages/pyq-detail";
import TestSeriesPage from "@/src/pages/test-series";
import TestSeriesDetailPage from "@/src/pages/test-series-detail";

export default function App() {
  return (
    <Chrome>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />

        <Route path="/courses/:slug" element={<CourseDetailPage />} />
        <Route path="/articles" element={<ArticlesPage />} />
        <Route path="/pyqs" element={<PyqsPage />} />
        <Route path="/current-affairs" element={<CurrentAffairsPage />} />
        <Route path="/current-affairs/:slug" element={<CurrentAffairsDetailPage />} />
        <Route path="/materials" element={<MaterialsPage />} />
        <Route path="/materials/:slug" element={<MaterialsDetailPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogDetailPage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/refund-policy" element={<RefundPolicyPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/admin/*" element={<AdminPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/quiz/:slug" element={<QuizPage />} />
        <Route path="/article/:slug" element={<ArticlePage />} />
        <Route path="/current-affairs" element={<CurrentAffairsPage />} />
        <Route path="/pyq/:slug" element={<PyqDetailPage />} />
        <Route path="/test-series" element={<TestSeriesPage />} />
        <Route path="/test-series/:slug" element={<TestSeriesDetailPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Chrome>
  );
}
